import React, { useState, useRef } from 'react';
import {
    Box,
    Button,
    Image,
    SimpleGrid,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    IconButton,
    AspectRatio,
} from '@chakra-ui/react';
import { BsCamera2 } from "react-icons/bs";

import Webcam from 'react-webcam';

const DisposableCameraPage = () => {
    const [photos, setPhotos] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const webcamRef = useRef(null);

    const handleCapture = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setPhotos([...photos, { src: imageSrc, id: Date.now() }]);
        onClose();
    };

    const handleUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setPhotos([...photos, { src: reader.result, id: Date.now() }]);
        };
        reader.readAsDataURL(file);
    };

    const sharedPhotos = [
        { id: 1, src: 'https://via.placeholder.com/150' },
        { id: 2, src: 'https://via.placeholder.com/150' },
        { id: 3, src: 'https://via.placeholder.com/150' },
        { id: 4, src: 'https://via.placeholder.com/150' },
        { id: 5, src: 'https://via.placeholder.com/150' },
        { id: 6, src: 'https://via.placeholder.com/150' },
        // Add more shared photos as needed
    ];

    return (
        <Box p={4}>
            <Box mb={4} textAlign="center">
                <Button colorScheme="teal" onClick={onOpen} leftIcon={<BsCamera2 />}>
                    Capture from Camera
                </Button>
                <Input
                    type="file"
                    accept="image/*"
                    onChange={handleUpload}
                    display="none"
                    id="file-upload"
                />
                <Button as="label" htmlFor="file-upload" ml={4}>
                    Upload from Files
                </Button>
            </Box>

            <Box>
                <SimpleGrid columns={{ base: 3, sm: 3, md: 3 }} spacing={1}>
                    {sharedPhotos.concat(photos).map((photo) => (
                        <Box key={photo.id} borderRadius="md" overflow="hidden">
                            <AspectRatio boxSize="150px" ratio={1 / 1}>
                                <Image src={photo.src} alt={`photo-${photo.id}`} boxSize="100%" objectFit="cover" />
                            </AspectRatio>
                        </Box>
                    ))}
                </SimpleGrid>
            </Box>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Capture Photo</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width="100%"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="teal" onClick={handleCapture}>
                            Capture
                        </Button>
                        <Button onClick={onClose} ml={3}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default DisposableCameraPage;
